var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagVaticanCity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16882)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 0.270508C24.8365 0.270508 32 7.43401 32 16.2705C32 25.107 24.8365 32.2705 16 32.2705C16 31.5749 13.9131 16.2705 13.9131 16.2705L16 0.270508Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 32.2705C7.1635 32.2705 0 25.107 0 16.2705C0 7.43401 7.1635 0.270508 16 0.270508",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1266 14.1934L25.1335 18.1713C24.6598 18.8886 24.6623 19.8551 25.2102 20.5799C25.9052 21.4994 27.214 21.6814 28.1335 20.9863C29.053 20.2913 29.235 18.9825 28.5399 18.0631C27.992 17.3382 27.0628 17.0723 26.2434 17.3324L21.5571 11.1328L20.4472 11.9718L18.7822 13.2302L20.4602 15.4499L22.1266 14.1934ZM26.4555 18.7665C26.762 18.5347 27.1984 18.5955 27.43 18.9019C27.6617 19.2084 27.6011 19.6447 27.2946 19.8764C26.9882 20.108 26.5519 20.0475 26.3202 19.7409C26.0884 19.4344 26.1491 18.9981 26.4555 18.7665Z",
    fill: "#ACABB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.284 15.45L28.962 13.2303L27.2971 11.9718L26.1873 11.1328L21.501 17.3324C20.6817 17.0722 19.7524 17.3383 19.2045 18.0631C18.5094 18.9826 18.6914 20.2913 19.6108 20.9863C20.5303 21.6813 21.8391 21.4994 22.5341 20.5799C23.082 19.8551 23.0845 18.8886 22.6108 18.1712L25.6177 14.1934L27.284 15.45ZM21.4242 19.7411C21.1926 20.0476 20.7563 20.1082 20.4498 19.8766C20.1433 19.6448 20.0827 19.2085 20.3144 18.902C20.546 18.5956 20.9823 18.5349 21.2889 18.7666C21.5953 18.9983 21.6559 19.4346 21.4242 19.7411Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16882"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.270508)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagVaticanCity);
export default __webpack_public_path__ + "static/media/flag_vatican_city.d93e2bc7ae61d195ebaa3eb1084d1e3f.svg";
export { ForwardRef as ReactComponent };